import React, { useEffect, useState, useRef, useContext } from 'react';
//@ts-ignore
import * as styles from './topiccallout.module.css';
import { graphql } from 'gatsby';
import ArrowLgButton from '../Global/ArrowLgButton';
import CtaLink from '../Global/CtaLink';

import {
    BrandColor,
    KontentStringValue,
    CTAConfiguration,
    CTALocation,
    KontentMedia,
    KontentRadioMultiChoice,
} from '../../../types/KontentProps';
import {
    getColor,
    getMediaData,
    getMultiChoice,
    optimizeKontentImageUrl,
    buildKontentSrcSet,
    imagePreset,
} from '../Global/DataUtils';

import { BuildLinkHref } from '../Global/BuildLinkHref';
import { getImageData } from '../Global/DataUtils/gatsbyImageUtils';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';
import { prefixWithLang } from '../../global/countries';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { getDevicePlatform } from '../../global/utility';

type galleryWidth = number;
type left = number;
type width = number;
type cardWidth = number;
type showWidth = number;
type dotsToShow = number;

type element = {
    content_panel__content_panel_color?: BrandColor;
    content_panel__content_panel_font_color?: BrandColor;
    headline: KontentStringValue;
    copy: KontentStringValue;
    primary_image: KontentMedia;
    secondary_image: KontentMedia;
    cta_configuration__cta_window_action: {
        value: [
            {
                name: string;
                codename: string;
            }
        ];
    };
    hide_cta: {
        value: [
            {
                codename: string;
            }
        ];
    };
    cta_configuration__cta_label: KontentStringValue;
    cta_configuration__cta_location: CTALocation;
    cta_configuration__cta_location_anchor_point: KontentStringValue;
};

type card = {
    value: { elements: element }[];
};

type layout = {
    value: {
        name: string;
    }[];
};

interface Props extends CTAConfiguration {
    kontentItemId?: string;
    cards: card;
    layout: layout;
    content_alignment: {
        value: [
            {
                codename: string;
            }
        ];
    };
    control_top_margin?: KontentRadioMultiChoice<string>;
    desktop_top_margin?: KontentStringValue;
    mobile_top_margin?: KontentStringValue;
}

const TopicCallOut: React.FC<Props> = ({
    cards,
    layout,
    content_alignment,
    control_top_margin,
    desktop_top_margin,
    mobile_top_margin,
    kontentItemId,
}) => {
    const CentercontentAlignment =
        content_alignment?.value[0]?.codename == 'center';
    const breakpoints = useBreakpoint();

    //corosal view render or not for mobile
    const isCorosal = layout?.value[0]?.name == 'Carousel' ? true : false;
    const [currentOffice, setCurrentOffice] = useState(0);
    const [currentPosition, setCurrentPosition] = useState(0);
    const [width, setWidth] = useState(0);
    const [left, setLeft] = useState(0);
    const galleryWrap: any = useRef(null);
    const pageMetadata = useContext(PageMetadataContext);
    const controlMargin = control_top_margin?.value?.[0]?.codename === 'yes';
    //swipe hand gesture
    const [touchStart, setTouchStart] = React.useState(0);
    const [touchEnd, setTouchEnd] = React.useState(0);

    const cardWidth = width > 1900 ? 425 : width > 410 ? 350 : 260;
    const galleryWidth = cards?.value?.length * cardWidth;
    const showWidth = width > 410 ? Math.floor((width - 50) / cardWidth) : 1;
    const dotsToShow =
        width > 410
            ? Math.ceil(galleryWidth / cardWidth / showWidth)
            : cards?.value.length;

    let clickNext = setGalleryPosition(
        galleryWidth,
        width,
        left,
        showWidth,
        cardWidth
    );
    let newGalleryWidth = setNewGalleryWidth(galleryWidth, width, cardWidth);

    const [isIOSorMacOS, setIsIOSorMacOS] = useState(false);

    const checkOS = () => {
        setIsIOSorMacOS(
            typeof window !== 'undefined' &&
                (!!navigator.userAgent.match(/Mac/i) ||
                    !!getDevicePlatform.iOS())
        );
    };

    useEffect(() => {
        checkOS();
    }, []);

    //register swipe
    function handleTouchStart(e: any) {
        setTouchStart(e.targetTouches[0].clientX);
    }

    function handleTouchMove(e: any) {
        setTouchEnd(e.targetTouches[0].clientX);
    }

    function handleTouchEnd() {
        if (touchStart - touchEnd > 150) {
            galleryWidth + 50 > width &&
            currentPosition + 1 < dotsToShow &&
            touchEnd > 0
                ? handleClickNext()
                : null;
        } else if (touchStart - touchEnd < -150) {
            galleryWidth > width && currentOffice > 0
                ? handleClickPrev()
                : null;
        }
    }

    //swipe code end here
    const handleClickNext = () => {
        setCurrentOffice(currentOffice + 1);
        setCurrentPosition(currentPosition + 1);
        setLeft(left - cardWidth * showWidth);
        //to prevent next move from click anywhere on right side/whole div
        setTouchEnd(0);
    };

    const handleClickPrev = () => {
        setCurrentOffice(currentOffice - 1);
        setCurrentPosition(currentPosition - 1);
        setLeft(left + cardWidth * showWidth);
    };

    const renderPrevButton = () => (
        <ArrowLgButton
            strokeColor="#f06623"
            direction="left"
            handleClick={handleClickPrev}
            className={styles.prevArrowButton}
        />
    );

    const renderNextButton = () => (
        <ArrowLgButton
            strokeColor="#f06623"
            direction="right"
            handleClick={handleClickNext}
            className={styles.nextArrowButton}
        />
    );

    const renderDots = (dotsToShow: number, currentPosition: number) => {
        let dots = [];

        for (let i = 0; i < dotsToShow; i++) {
            dots.push(
                <span
                    key={i}
                    style={currentPosition == i ? { background: '#ccc' } : {}}
                ></span>
            );
        }

        return dots;
    };

    useEffect(() => {
        const resizeListener = () => {
            if (isCorosal)
                setWidth(galleryWrap.current?.getBoundingClientRect().width);
        };

        resizeListener();
        window.addEventListener('resize', resizeListener);

        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, []);
    //@ts-ignore
    const renderView = (
        item: { elements: element },
        key: number,
        corosal: boolean
    ) => {
        const {
            copy,
            cta_configuration__cta_location,
            cta_configuration__cta_location_anchor_point,
            cta_configuration__cta_label,
            cta_configuration__cta_window_action,
            headline,
            primary_image,
            secondary_image,
            content_panel__content_panel_color,
            content_panel__content_panel_font_color,
        } = item.elements;
        const CardWrapper = cta_configuration__cta_label?.value ? 'a' : 'div';
        const isCtaHidden = item?.elements.hide_cta?.value[0]?.codename;
        const contentPanelColor = getColor(content_panel__content_panel_color);
        const contentPanelFontColor = getColor(
            content_panel__content_panel_font_color
        );
        const textColor = contentPanelFontColor ? contentPanelFontColor : '';
        const backgroundColor = contentPanelColor ? contentPanelColor : '';
        const ctaLocation = BuildLinkHref(
            cta_configuration__cta_location,
            cta_configuration__cta_location_anchor_point
        );
        const ctaWindowAction =
            getMultiChoice(cta_configuration__cta_window_action) ===
            'new_window'
                ? '_blank'
                : '_self';

        const primaryImage = getImageData(primary_image);

        return (
            <>
                {isCtaHidden == 'yes' &&
                    cta_configuration__cta_label?.value && (
                        <style>{`.${styles.card}:hover { 
                        transform: translate3D(0, -1px, 0) scale(1.03);
                        box-shadow: 8px 28px 50px rgba(39, 44, 49, 0.07), 1px 6px 12px rgba(39, 44, 49, 0.04);
                        transition: all 0.4s ease;
                        cursor: pointer;
                    }`}</style>
                    )}
                <li
                    className={`${styles.cards__item} ${
                        !isCorosal ||
                        (breakpoints.md && isCorosal && cards.value.length <= 4)
                            ? styles.stackspecificstyles
                            : undefined
                    }`}
                    key={key}
                    style={
                        CentercontentAlignment ? { textAlign: 'center' } : {}
                    }
                >
                    <CardWrapper
                        {...(CardWrapper === 'a'
                            ? {
                                  href: prefixWithLang(
                                      ctaLocation,
                                      pageMetadata?.preferredLanguage
                                  ),
                                  target: ctaWindowAction,
                              }
                            : {})}
                        className={styles.card}
                    >
                        {primaryImage?.image && (
                            <div data-kontent-element-codename="primary_image">
                                <img
                                    src={
                                        primaryImage.image
                                            ? optimizeKontentImageUrl(
                                                  (primaryImage.image?.url ||
                                                      primaryImage.image) as string,
                                                  {
                                                      w: 800,
                                                      fit: 'crop',
                                                      q: 80,
                                                      auto: 'format',
                                                  }
                                              )
                                            : ''
                                    }
                                    srcSet={
                                        primaryImage.image
                                            ? buildKontentSrcSet(
                                                  (primaryImage.image?.url ||
                                                      primaryImage.image) as string,
                                                  800,
                                                  {
                                                      fit: 'crop',
                                                      q: 80,
                                                      auto: 'format',
                                                  }
                                              )
                                            : ''
                                    }
                                    sizes="(max-width: 800px) 100vw, 800px"
                                    alt={primaryImage.alt}
                                    width={800}
                                    height={undefined}
                                    loading="lazy"
                                    className={styles.cardimage}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        objectFit: 'cover',
                                    }}
                                />
                            </div>
                        )}

                        <div
                            className={styles.card__content}
                            style={{
                                backgroundColor: backgroundColor,
                                color: textColor,
                            }}
                        >
                            {getMediaData(secondary_image)?.url && (
                                <div data-kontent-element-codename="secondary_image">
                                    <img
                                        src={optimizeKontentImageUrl(
                                            getMediaData(secondary_image)
                                                ?.url as string,
                                            {
                                                ...imagePreset.card.desktop,
                                                q: 95,
                                            }
                                        )}
                                        srcSet={buildKontentSrcSet(
                                            getMediaData(secondary_image)
                                                ?.url as string,
                                            imagePreset.card.desktop.w,
                                            {
                                                fm: 'webp' as const,
                                                q: 95,
                                            }
                                        )}
                                        sizes="(max-width: 768px) 100vw, 25vw"
                                        className={styles.bgimage}
                                        alt={
                                            getMediaData(secondary_image)
                                                ?.description || ''
                                        }
                                        loading="lazy"
                                    />
                                </div>
                            )}
                            <div
                                className={styles.card__title}
                                style={{
                                    color: textColor,
                                }}
                                data-kontent-element-codename="headline"
                            >
                                {headline?.value}
                            </div>
                            <p
                                data-kontent-element-codename="copy"
                                className={`${styles.card__text} ${
                                    isCorosal &&
                                    breakpoints.md &&
                                    cards.value.length <= 4
                                        ? ''
                                        : isCorosal
                                        ? styles.card__text__height
                                        : ''
                                }`}
                            >
                                {copy?.value}{' '}
                            </p>

                            {isCtaHidden !== 'yes' && (
                                <CtaLink
                                    href={BuildLinkHref(
                                        cta_configuration__cta_location
                                    )}
                                    target={ctaWindowAction}
                                    visualStyle="outlineLight"
                                    className={styles.ctaBlock}
                                >
                                    {cta_configuration__cta_label?.value}
                                </CtaLink>
                            )}
                        </div>
                    </CardWrapper>
                </li>
            </>
        );
    };

    const CorosalView = (item: { elements: element }, cardIdx: number) => {
        //corosal view
        return (
            <div className={styles.officeCard} key={cardIdx}>
                <div className={styles.card}>
                    <div className={styles.row}>
                        {renderView(item, cardIdx, true)}
                    </div>
                </div>
            </div>
        );
    };

    const renderMobileView = () => {
        return (
            <div>
                {cards?.value.map(
                    (item: { elements: element }, index: number) => {
                        return renderView(item, index, false);
                    }
                )}
            </div>
        );
    };

    const renderCorosalView = () => {
        return (
            <div
                ref={galleryWrap}
                className={styles.wrapper}
                onTouchStart={(touchStartEvent) =>
                    handleTouchStart(touchStartEvent)
                }
                onTouchMove={(touchMoveEvent) =>
                    handleTouchMove(touchMoveEvent)
                }
                onTouchEnd={() => handleTouchEnd()}
            >
                <div
                    id={styles.gallery}
                    className={styles.gallery}
                    style={newGalleryWidth}
                >
                    {galleryWidth + 50 > width && currentOffice > 0
                        ? renderPrevButton()
                        : null}

                    <div
                        style={clickNext}
                        className={
                            breakpoints.xl && cards.value.length < 6
                                ? styles.centeredGallary
                                : ''
                        }
                    >
                        {cards?.value.map(
                            (item: { elements: element }, index: number) => {
                                return CorosalView(item, index);
                            }
                        )}
                    </div>

                    {galleryWidth + (breakpoints.md ? 50 : 0) > width &&
                    currentPosition + 1 < dotsToShow
                        ? renderNextButton()
                        : null}
                </div>
                <div className={styles.dots}>
                    {renderDots(dotsToShow, currentPosition)}
                </div>
            </div>
        );
    };
    return (
        <div data-kontent-item-id={kontentItemId}>
            {!isCorosal ? (
                <div>
                    <ul
                        className={styles.cards}
                        style={
                            controlMargin
                                ? {
                                      marginTop:
                                          breakpoints.md &&
                                          desktop_top_margin?.value
                                              ? desktop_top_margin.value
                                              : mobile_top_margin?.value ||
                                                undefined,
                                  }
                                : undefined
                        }
                    >
                        {cards?.value.map(
                            (item: { elements: element }, index: number) => {
                                return renderView(item, index, false);
                            }
                        )}
                    </ul>
                </div>
            ) : (
                <>
                    <div>
                        {isCorosal &&
                        breakpoints.md &&
                        cards.value.length <= 4 ? (
                            <div>
                                <ul
                                    className={`${styles.cards}`}
                                    style={
                                        controlMargin
                                            ? {
                                                  marginTop:
                                                      breakpoints.md &&
                                                      desktop_top_margin?.value
                                                          ? desktop_top_margin.value
                                                          : mobile_top_margin?.value ||
                                                            undefined,
                                              }
                                            : undefined
                                    }
                                >
                                    {cards?.value.map(
                                        (
                                            item: { elements: element },
                                            index: number
                                        ) => {
                                            return renderView(
                                                item,
                                                index,
                                                false
                                            );
                                        }
                                    )}
                                </ul>
                            </div>
                        ) : isCorosal ? (
                            renderCorosalView()
                        ) : (
                            renderMobileView()
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default TopicCallOut;

function setGalleryPosition(
    galleryWidth: galleryWidth,
    width: width,
    marginLeft: left,
    showWidth: showWidth,
    cardWidth: cardWidth
) {
    let newWidth;

    if (galleryWidth < width) {
        if (width / showWidth > cardWidth) {
            newWidth = galleryWidth + cardWidth;
        } else {
            newWidth = width;
        }
    } else {
        newWidth = galleryWidth;
    }
    const galleryPosition: React.CSSProperties = {
        width: newWidth,
        marginLeft: marginLeft,
        transition: 'margin .5s ease-in-out',
    };

    return galleryPosition;
}

function setNewGalleryWidth(
    galleryWidth: galleryWidth,
    width: width,
    cardWidth: cardWidth
) {
    let showWidth = 1;
    let newGalleryWidth = showWidth * cardWidth;

    if (width > 320) {
        showWidth = Math.floor((width - 50) / cardWidth);
        newGalleryWidth = showWidth * cardWidth;
    }

    const galleryInsideWidth: React.CSSProperties = {
        width: newGalleryWidth,
    };

    return galleryInsideWidth;
}

export const query = graphql`
    fragment TopicCallOut on kontent_item_component___topic_call_outs {
        elements {
            layout {
                value {
                    name
                }
            }
            content_alignment {
                value {
                    codename
                }
            }
            desktop_top_margin {
                value
            }
            mobile_top_margin {
                value
            }
            control_top_margin {
                value {
                    name
                    codename
                }
            }
            cards {
                value {
                    ... on kontent_item_content_item___topic_card {
                        id
                        elements {
                            headline {
                                value
                            }
                            hide_cta {
                                value {
                                    codename
                                }
                            }
                            copy {
                                value
                            }
                            cta_configuration__cta_label {
                                value
                            }
                            cta_configuration__cta_location {
                                ...kontentCtaLocation
                            }
                            primary_image {
                                ...kontentImage
                            }
                            secondary_image {
                                value {
                                    ... on kontent_item_media___image {
                                        id
                                        elements {
                                            file {
                                                value {
                                                    name
                                                    url
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            cta_configuration__cta_location_anchor_point {
                                value
                            }
                            cta_configuration__cta_window_action {
                                value {
                                    name
                                }
                            }
                            content_panel__content_panel_color {
                                value {
                                    ... on kontent_item_list___brand_colors {
                                        id
                                        elements {
                                            color_hex_value {
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                            content_panel__content_panel_font_color {
                                value {
                                    ... on kontent_item_list___brand_colors {
                                        id
                                        elements {
                                            color_hex_value {
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
